(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jaypads-music-archive"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.jpMusicPlayerInitialized) return;
    window.jpMusicPlayerInitialized = true;

    const preparedDialogs = new WeakSet();

    const stopPlayer = (dialog) => {
      const host = dialog.querySelector('[data-jp-player-host]');
      const poster = dialog.querySelector('[data-jp-player-poster]');
      if (host) host.replaceChildren();
      if (poster) {
        poster.removeAttribute('src');
        poster.hidden = true;
      }
      dialog.dataset.state = 'poster';
      document.documentElement.classList.remove('jp-player-open');
    };

    const prepareDialog = (dialog) => {
      if (preparedDialogs.has(dialog)) return;

      const closeButton = dialog.querySelector('[data-jp-player-close]');
      const startButton = dialog.querySelector('[data-jp-player-start]');

      closeButton?.addEventListener('click', () => dialog.close());

      startButton?.addEventListener('click', () => {
        const videoId = dialog.dataset.videoId;
        const host = dialog.querySelector('[data-jp-player-host]');
        if (!videoId || !host) return;

        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
        iframe.title = dialog.dataset.videoTitle || 'YouTube visualizer';
        iframe.loading = 'eager';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        host.replaceChildren(iframe);
        dialog.dataset.state = 'playing';
        closeButton?.focus({ preventScroll: true });
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      dialog.addEventListener('close', () => {
        const trigger = dialog.jpMusicTrigger;
        stopPlayer(dialog);
        if (trigger?.isConnected) trigger.focus({ preventScroll: true });
        dialog.jpMusicTrigger = null;
      });

      preparedDialogs.add(dialog);
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-jp-video]');
      if (!trigger) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const videoId = trigger.dataset.videoId;
      const dialog = document.querySelector('[data-jp-player-dialog]');
      if (!videoId || !dialog || typeof dialog.showModal !== 'function') return;

      event.preventDefault();
      prepareDialog(dialog);

      if (dialog.open) dialog.close();

      const title = trigger.dataset.videoTitle || '';
      const date = trigger.dataset.videoDate || '';
      const duration = trigger.dataset.videoDuration || '';
      const image = trigger.dataset.videoImage || '';
      const titleNode = dialog.querySelector('[data-jp-player-title]');
      const metaNode = dialog.querySelector('[data-jp-player-meta]');
      const poster = dialog.querySelector('[data-jp-player-poster]');
      const external = dialog.querySelector('[data-jp-player-external]');

      dialog.jpMusicTrigger = trigger;
      dialog.dataset.videoId = videoId;
      dialog.dataset.videoTitle = title;
      dialog.dataset.state = 'poster';

      if (titleNode) titleNode.textContent = title;
      if (metaNode) metaNode.textContent = [date, duration, 'VISUALIZER'].filter(Boolean).join(' · ');
      if (external) external.href = trigger.href;
      if (poster) {
        poster.hidden = !image;
        if (image) poster.src = image;
      }

      document.documentElement.classList.add('jp-player-open');
      dialog.showModal();
      requestAnimationFrame(() => dialog.querySelector('[data-jp-player-start]')?.focus({ preventScroll: true }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
